module.exports = "/fonts/Inter_cyrillic.woff2";